import { render } from "./NoContent.vue?vue&type=template&id=8440f944"
import script from "./NoContent.vue?vue&type=script&lang=js"
export * from "./NoContent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Murilo\\Documents\\app-construp-cms\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__